import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/long_sleeve_dress.png";

function LongSleeveDress() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите ваше любимое платье (желательно с рукавами) и проведите
          измерения:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>Измерьте длину спины по центру (c).</li>
          <li>
            Измерьте ширину плеч от шва до шва, как указано на рисунке в таблице
            размеров (d).
          </li>
          <li>Измерьте ширину пояса вашего платья (e).</li>
          <li>Измерьте ширину в бёдрах, в самом широком месте платья (f).</li>
          <li>Измерьте ширину низа вашего платья (g).</li>
          <li>Измерьте ширину рукава в месте, где он пришит (h).</li>
          <li>Измерьте длину рукава от шва (i).</li>
          <li>
            В нашей таблице размеров найдите показатели, которые наиболее точно
            соответствуют получившимся цифрам.
          </li>
        </ol>
      </Grid>
    </Grid>
  );
}

LongSleeveDress.propTypes = {};

export default LongSleeveDress;
